import React, {useState, createContext} from 'react'

export const RepeatableContext = createContext()

export const RepeatableProvider = (props) => {
    const[repeatableState, setRepeatableState] = useState({})
    return (
        <RepeatableContext.Provider value={[repeatableState,setRepeatableState]}>
            {props.children}
        </RepeatableContext.Provider>
    )
}